import { useState } from 'react'
import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { processText } from '@aytm/app/stats/page/components/lib/utils'
import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

import { resolveThumbSrc, isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

// components
import ImagePreview from '@aytm/app/stats/components/image-preview/ImagePreview'
import { pressable } from '@aytm/app/stats/components/lib/pressable'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

// styles
import style from '@aytm/app/stats/page/question-views/va/styles/Block.module.scss'

const Block = ({
  id,
  link,
  video,
  image,
  va_instructions,
  va_choice_type,
  answer,
  answerVariants,
  components,
  isSurveyGuest,
  isReportXpert
}) => {
  const [showVideo, setShowVideo] = useState(false)

  return (
    <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
      {va_choice_type == 0 ? (
        video != undefined ? (
          <div className={style.video} style={{ '--video-ratio': video.ratio || 0.5 }}>
            {showVideo ? (
              <video
                id={`html5_id-${id}`}
                className={style.player}
                poster={resolveThumbSrc(video)}
                preload="auto"
                controls
                autoPlay
                controlsList="nodownload"
              >
                <source src={video.mp4File} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
              </video>
            ) : (
              <div
                className={style['video-thumbnail']}
                aria-label="Play video"
                {...pressable(() => setShowVideo(true))}
              >
                <img className={style.player} src={resolveThumbSrc(video)} alt="" />
                <img className={style['video-thumbnail-playback']} src="/images/ico/video-playback.png" alt="" />
              </div>
            )}
          </div>
        ) : (
          <div className={style.video}>
            <img src="/images/external_survey/missing_video.png" alt="" />
          </div>
        )
      ) : va_choice_type == 1 ? (
        <div className={style.image}>
          {undefined != image && undefined != image.original ? (
            <ImagePreview
              className={style['image-box']}
              minWidth="50px"
              maxWidth="600px"
              minHeight="50px"
              maxHeight="600px"
              imageUrl={image.original.url}
              previewUrl={getImageAssetPath({
                path: image.original.path,
                width: 600,
                height: 600,
                filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
                backgroundColor: 'white'
              })}
              allowScrolling={image.scrolling}
            />
          ) : null}
        </div>
      ) : va_choice_type == 2 ? (
        <div className={style.instructions} dangerouslySetInnerHTML={{ __html: processText(va_instructions) }} />
      ) : null}
      {isComponentOn(components, 'table') && (
        <div className={style.answers}>
          <div className={style['answers-header']}>Points</div>
          {(answerVariants || []).map(variant => (
            <div key={variant.position} data-row-position={variant.position} className={style['answers-row']}>
              <div className={style['answers-label']}>{`A${variant.position}:`}</div>
              <div className={style['answers-text']} dangerouslySetInnerHTML={{ __html: processText(variant.text) }} />
            </div>
          ))}
        </div>
      )}
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  link: PropTypes.string,
  video: PropTypes.object,
  image: PropTypes.object,
  va_instructions: PropTypes.string,
  va_choice_type: PropTypes.number,
  answer: answerPropType,
  answerVariants: PropTypes.array,
  components: PropTypes.object,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool
}

export default Block
